import React, { useEffect } from 'react';
import './../assets/css/whitelabel/index.css'
import { useWhiteLabel } from './../hooks/useWhiteLabel';

export default function WhitelabelTheme(){

  const whitelabel = useWhiteLabel();

  useEffect(() => {
    console.log(`SPA ${whitelabel.spaTitle}`);

    if(whitelabel.spaTitle === undefined) return;

    switch(whitelabel?.spaTitle) {
      case 'ChatsHub':
        console.log('Carregando estilo da Chatshub...');
        import (`./../assets/whitelabel-clients/chatshub/default.css`);
        break;
      case 'Auvo':
        console.log('Carregando estilo da Auvo...');
        import (`./../assets/whitelabel-clients/auvo/default.css`);
        break;
      case 'Iter Up':
        console.log('Carregando estilo da Iter Up...');
        import (`./../assets/whitelabel-clients/iterup/default.css`);
        break;
      case 'AQ Bank':
        console.log('Carregando estilo da AQ Bank...');
        import (`./../assets/whitelabel-clients/aqbank/default.css`);
        break;
      case 'Codemed':
        console.log('Carregando estilo da Codemed...')
        import(`./../assets/whitelabel-clients/codemed/default.css`);
        break;    
      case 'Lite It':
        console.log('Carregando estilo da Lite It...')
        import(`./../assets/whitelabel-clients/liteit/default.css`);
        break;
      case 'Lite It':
        console.log('Carregando estilo da Lite It...')
        import(`./../assets/whitelabel-clients/liteit/default.css`);
        break;
      case 'Lite It':
        console.log('Carregando estilo da Lite It...')
        import(`./../assets/whitelabel-clients/liteit/default.css`);
        break;
      case 'NectarCRM':
        console.log('Carregando estilo da NectarCRM...')
        import(`./../assets/whitelabel-clients/nectarcrm/default.css`);
        break;
      case 'Usecredituz':
        console.log('Carregando estilo da Usecredituz...')
        import(`./../assets/whitelabel-clients/usecredituz/default.css`);
        break;
      default:
        console.log('Estilo vazio...');
        return;
    }

}, [whitelabel.spaTitle]);

  return (
    <>
    </>
  );
}
